<template id=roleScreen>
    <div class="role-container col-sm-5 col-md-5 col-lg-9">
        <div class="d-flex w-50 m-auto p-5 justify-content-center flex-column login">
            <b-overlay rounded="lg">
                <h3>Select Role</h3>
                <form action="">
                    <div class="form-group">
                        <v-select v-model="roles" :options="roleName"></v-select>
                    </div>
                    <button class="btn btn-primary btn-sm" v-on:click="selectRole(roles)">
                        Proceed
                    </button>
                </form>
            </b-overlay>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'roleScreen',
    data () {
      return {
        roleData: [],
        roleName: [],
        roles: []
      }
    },
    created () {
      this.loadRoles()
    },
    methods: {
      //Passing role
      selectRole: function (roles) {
        console.log('Testing Passed roles', roles)
      },
      loadRoles: function () {
        this.$store.dispatch("loadState").then(() => {
          this.roleData = this.$store.state.roleSwitch
          this.roleName = Array.from(new Set(this.roleData.map(r => r.roleName).filter(x => x != null)))
        })
      }
    }
  }
</script>

<style scoped>
    .role-container {
        justify-content: center;
        align-content: center;
        align-items: center;
        align-self: center;
    }

    .login {
        box-shadow: 1px 2px 2px 3px #a7aeaa;
    }
</style>